module.exports = __webpack_public_path__ + "static/img/LiveRamp-Selected.eef45d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/dataSources/LiveRamp-Selected.png
// module id = 1570
// module chunks = 0